import React, { useState } from 'react';
import { CopyToClipboard } from "react-copy-to-clipboard";
import { Multiselect } from "multiselect-react-dropdown";
import country_currency from "./country_currency.json";

function LocalBusiness() {
  const [copied, setCopied] = React.useState(false); 
  const [stateData, setStateData] = useState([]);
  const [inputFieldsEv1, setInputFieldsEv1] = useState({
    'local_business_type': "LocalBusiness",
    name: '',
    imageurl: '',
    id: '',
    url: '',
    phone_no: '',
    price_range: ''

  })
  const [addressFieldsEv1, setAddressFieldsEv1] = useState({
    '@type': "PostalAddress",
    street: '',
    city: '',
    zipcode: '',
    country: '',
    latitude: '',
    logitude: '',

  })
  const [inputFieldsEv, setInputFieldsEv] = useState([{
    days: '',
    opens: '',
    closes: ''
  }])
  const [daysArr, setDaysArr] = useState([{}]);

  const sportsData = [
    { id: 'Facebook', name: 'Facebook' },
    { id: 'Twitter', name: 'Twitter' },
    { id: 'Instagram', name: 'Instagram' },
    { id: 'YouTube', name: 'YouTube' },
    { id: 'LinkedIn', name: 'LinkedIn' },
    { id: 'Pinterest', name: 'Pinterest' },
    { id: 'SoundCloud', name: 'SoundCloud' },
    { id: 'Tumblr', name: 'Tumblr' },
    { id: 'Wikipedia', name: 'Wikipedia' },
    { id: 'Github', name: 'Github' },
    { id: 'Website', name: 'Website' }
  ];
  const daysData = [
    { id: 'Monday', name: 'Monday' },
    { id: 'Tuesday', name: 'Tuesday' },
    { id: 'Wednesday', name: 'Wednesday' },
    { id: 'Thursday', name: 'Thursday' },
    { id: 'Friday', name: 'Friday' },
    { id: 'Saturday', name: 'Saturday' },
    { id: 'Sunday', name: 'Sunday' }
  ];

  const [inputFieldsJp9, setInputFieldsJp9] = useState([])
  const [selectedVal, setSelectedVal] = useState([{}]); 
  const [checked, setChecked] = useState(false); 

  const handleChange8 = (newState = {}) => {
    const tempState = { ...selectedVal, ...newState };
    setSelectedVal(tempState);
  };
  const openTypeBox = () =>{
    setChecked(!checked);
  } 
  const handleChangeAddress = (event) => {
    let value = event.target.value;
    let name = event.target.name;
    setAddressFieldsEv1((prevalue) => {
      return {
        ...prevalue,   // Spread Operator              
        [name]: value
      }
    })
  }
  const handleChange9 = (event) => {
    let value = event.target.value;
    let name = event.target.name;
    setInputFieldsJp9((prevalue) => {
      return {
        ...prevalue,   // Spread Operator              
        [name]: value
      }
    })
  }
  const handleChange4 = (newState = {}) => {
    setInputFieldsJp9(newState);
    setSelectedVal(newState);
  };
  
  const handleChangeDays = (index, event) =>{
      const tempdays = { ...daysArr, [index]:event, index };
      setDaysArr(tempdays); 
  }
  const handleRemoveDays = (newState = {}, ind) =>{
    const tempState = { ...daysArr, [ind]:newState, ind };
    setDaysArr(tempState);
  }
 
  const handleChange5 = (event) => {
    let value = event.target.value;
    let name = event.target.name;
    // if (name === 'image') {
    //   let isTrueImage = !value || urlPatternValidation(value);
    //   if (isTrueImage === false) {
    //     setIsTrueIMg(true);
    //   }
    //   else {
    //     setIsTrueIMg(false);
    //   }
    // }
    setInputFieldsEv1((prevalue) => {
      return {
        ...prevalue,   // Spread Operator              
        [name]: value
      }
    })
    if (name === 'local_business_type') {
      country_currency.countries.organizationType.map(function (item, i) {
        if (item.id === value) {
          setStateData((prevState) => ({
            ...prevState,
            data: item.moreType
          }));
        }
        return item;
      })
    }
  }
  const handleChange2 = (indexs, evnt) => {
    const { name, value } = evnt.target;     
    const list = [...inputFieldsEv];
    list[indexs][name] = value;
    setInputFieldsEv(list);
  }
  function MyButton(props) {
    return <button {...props} />
  }

  const addInputFieldEv = () => {
    setInputFieldsEv([...inputFieldsEv, {
      days: '',
      opens: '',
      closes: ''
    }])
  }
  const removeInputFieldsEv = (index) => {
    const rows = [...inputFieldsEv];
    rows.splice(index, 1);
    setInputFieldsEv(rows);
  }

  const onCopy = React.useCallback(() => {
    setCopied(true);
    setTimeout(function () {
      setCopied(false);
    }, 3000);
  }, [])
  
  const arrdays = (index) =>{
    let days = [];
    if(daysArr[index] !== undefined){
      Object.values(daysArr[index]).map((item)=>{
        if(item.name !== undefined){
          days.push('"'+item.name+'"');
        }
      });
    }
    return days;
  }
   
  const moreAddContactStep = inputFieldsEv.map((item, ind) =>
    `{
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": [`+ arrdays(ind) + `],
      "opens": "`+ item.opens + `",
      "closes": "`+ item.closes + `"
      }`
  );
  const addContact = (inputFieldsEv.length === 1) ? `"openingHoursSpecification": [{
    "@type": "OpeningHoursSpecification",
    "dayOfWeek": [`+ arrdays(0) + `],
    "opens": "`+ inputFieldsEv[0].opens + `",
    "closes": "`+ inputFieldsEv[0].closes + `"
  }],`: `"openingHoursSpecification": [` + moreAddContactStep + `],`;
  const open247 = ` "openingHoursSpecification":[{
    "@type": "OpeningHoursSpecification",
    "dayOfWeek": [
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
      "Sunday"
    ],
    "opens": "00:00",
    "closes": "23:59"
  }],`;
  const openingHoursSpecification = (checked === false)?addContact:open247; 
  const sameAs = `"sameAs": [
    `+ Object.values(inputFieldsJp9).map((items) =>
    JSON.stringify(items)
  ) + `
  ]`;

  const addresss = `"address": {
    "@type": "PostalAddress",
    "streetAddress": "`+addressFieldsEv1.street+`",
    "addressLocality": "`+addressFieldsEv1.city+`",
    "postalCode": "`+addressFieldsEv1.zipcode+`",
    "addressCountry": "`+addressFieldsEv1.country+`"
  },`;
  const geo =(addressFieldsEv1.latitude !=='')?`"geo": {
    "@type": "GeoCoordinates",
    "latitude": "`+addressFieldsEv1.latitude+`",
    "longitude": "`+addressFieldsEv1.logitude+`"
  },`:'';
  const EvIsMyCopy = `<script type="application/ld+json">{
    "@context": "https://schema.org",
    "@type": "`+inputFieldsEv1.local_business_type+`",
    "name": "`+inputFieldsEv1.name+`",
    "image": "`+inputFieldsEv1.imageurl+`",
    "@id": "`+inputFieldsEv1.id+`",
    "url": "`+inputFieldsEv1.url+`",
    "telephone": "`+inputFieldsEv1.phone_no+`",
    "priceRange": "`+inputFieldsEv1.price_range+`",
    `+addresss+`
    `+geo+`
    `+ openingHoursSpecification + `
    `+ sameAs + `      
  }
  </script><!--Local Bussiness Code Generated by https://w3speedup.com/tools/schema-markup-generator/ -->`;
  
  const resetFun = () =>{
    const inputFieldsEv1er = {
      'local_business_type': "",
      name: '',
      imageurl: '',
      id: '',
      url: '',
      phone_no: '',
      price_range: ''
  
    };
    setInputFieldsEv1(inputFieldsEv1er);
  }
  return (
    <div className='container-flude'>
      <div className='row mt-5 local_business_row'>
        <div className='col-md-8 mb-5 border'>
          <div className='mt-2 mb-2 organization_title'><i className="fa-sharp fa-solid fa-location-pin"></i> <b>Local Business Markup </b></div>
          <hr />
          <div className="row input_fields d-flex pb-5">
            <div className="col-12">
              <div className="form-group me-2 mb-2">
                <select onChange={(evnt) => handleChange5(evnt)} value={inputFieldsEv1.local_business_type} name="local_business_type" className="form-control">
                  <option value="">
                    Business Type
                  </option>
                  {country_currency.countries.organizationType && country_currency.countries.organizationType.map((value, index) => {
                    return (
                      <option key={index} value={value.id}>
                        {value.name.length > 70 ?
                          `${value.name.substring(0, 70)}...` : value.name
                        }
                      </option>
                    )
                  })}
                </select>
                <i className="fa-solid fa-caret-down"></i>
              </div>
            </div>
            <div className="col-12">
              <div className="form-group me-2 mb-2">
                <select onChange={(evnt) => handleChange5(evnt)} value={inputFieldsEv1.more_type} name="more_type" className="form-control">
                  <option value="">
                    More specific @type
                  </option>
                  {stateData.data && stateData.data.map((value, index) => {
                    return (
                      <option key={index} value={value.id}>
                        {value.name}
                      </option>
                    )
                  })}
                </select>
                <i className="fa-solid fa-caret-down"></i>
              </div>
            </div>
            <div className="col-4">
              <div className="form-group me-2 mb-2">
                <input type="text" onChange={(evnt) => handleChange5(evnt)} value={inputFieldsEv1.name} name="name" className="form-control" placeholder="Business Name" />
              </div>
            </div>
            <div className="col-4">
              <div className="form-group me-2 mb-2">
                <input type="url" onChange={(evnt) => handleChange5(evnt)} value={inputFieldsEv1.imageurl} name="imageurl" className="form-control" placeholder="Image URL" />
              </div>
            </div>
            <div className="col-4">
              <div className="form-group me-2 mb-2">
                <input type="url" onChange={(evnt) => handleChange5(evnt)} value={inputFieldsEv1.id} name="id" className="form-control" placeholder="id (URL)" />
              </div>
            </div>
            <div className="col-4">
              <div className="form-group me-2 mb-2">
                <input type="url" onChange={(evnt) => handleChange5(evnt)} value={inputFieldsEv1.url} name="url" className="form-control" placeholder="URL" />
              </div>
            </div>
            <div className="col-4">
              <div className="form-group me-2 mb-2">
                <input type="text" onChange={(evnt) => handleChange5(evnt)} value={inputFieldsEv1.phone_no} name="phone_no" className="form-control" placeholder="Phone (e.g. +1-800-555-1212)" />
              </div>
            </div>
            <div className="col-4">
              <div className="form-group me-2 mb-2">
                <input type="text" onChange={(evnt) => handleChange5(evnt)} value={inputFieldsEv1.price_range} name="price_range" className="form-control" placeholder="Price range" />
              </div>
            </div>
            <div className='mt-2 mb-2 organization_title'><i className="fa-sharp fa-solid fa-location-pin"></i> <b>Address</b></div>

            <div className="col-4">
              <div className="form-group me-2 mb-2">
                <input type="text" onChange={(evnt) => handleChangeAddress(evnt)} value={addressFieldsEv1.street} name="street" className="form-control" placeholder="Street" />
              </div>
            </div>
            <div className="col-4">
              <div className="form-group me-2 mb-2">
                <input type="text" onChange={(evnt) => handleChangeAddress(evnt)} value={addressFieldsEv1.city} name="city" className="form-control" placeholder="City" />
              </div>
            </div>
            <div className="col-4">
              <div className="form-group me-2 mb-2">
                <input type="text" onChange={(evnt) => handleChangeAddress(evnt)} value={addressFieldsEv1.zipcode} name="zipcode" className="form-control" placeholder="Zip code" />
              </div>
            </div>
            <div className="col-12">
              <div className="form-group me-2 mb-2">
                <select onChange={(evnt) => handleChangeAddress(evnt)} value={addressFieldsEv1.country} name="country" className="form-control">
                  <option>Select </option>
                  {country_currency.countries.country && country_currency.countries.country.map((value, index) => {
                    return (
                      <option key={index} value={value.countryCode}>
                        {value.countryName}
                      </option>
                    )
                  })}
                </select>
                <i className="fa-solid fa-caret-down"></i>
              </div>
            </div>
            <div className="col-4">
              <div className="form-group me-2 mb-2">
                <input type="text" onChange={(evnt) => handleChangeAddress(evnt)} value={addressFieldsEv1.latitude} name="latitude" className="form-control" placeholder="Latitude" />
              </div>
            </div>
            <div className="col-4">
              <div className="form-group me-2 mb-2">
                <input type="text" onChange={(evnt) => handleChangeAddress(evnt)} value={addressFieldsEv1.logitude} name="logitude" className="form-control" placeholder="Longitude" />
              </div>
            </div>
            <div className="col-4">
              <div className="form-group me-2 mb-2">
                <button className="btn btn-success  addticket get_coordinate"><i className="fa-sharp fa-solid fa-location-pin"></i> Get coordinates</button>
              </div>
            </div>

            <div className='mt-2 mb-2 organization_title openbox247input'>
              <i className="fa-regular fa-clock"></i>
              <b> Opening Hours</b> 
              <input type="checkbox" defaultChecked={checked} onChange={openTypeBox} className="openbox247"/> 
              <label>Open 24/7?</label>
            </div> 
            {(checked === false)?
                (inputFieldsEv.length > 0) && inputFieldsEv &&  Object.values(inputFieldsEv).map((data, index)=>{
                  const { opens, closes } = data; 
                  return (
                    <div className='row' key={index}> 
                      <div className="col-5">
                        <div className="form-group me-2 mb-2">
                          <label>Day(s) of weeks</label>
                          <Multiselect
                            options={daysData}
                            name="days"
                            displayValue="name"
                            placeholder='Days'
                            showCheckbox={true}
                            onRemove={(evnt) => handleRemoveDays(index,evnt)}
                            onSelect={(evnt) => handleChangeDays(index, evnt)}
                          />
                          {/* <select onChange={(evnt) => handleChange2(index, evnt)} value={days} name="days" className="form-control">
                            <option value="">Select Day</option>
                            <option value="Monday">Monday</option>
                            <option value="Tuesday">Tuesday</option>
                            <option value="Wednesday">Wednesday</option>
                            <option value="Thursday">Thursday</option>
                            <option value="Friday">Friday</option>
                            <option value="Saturday">Saturday</option>
                            <option value="Sunday">Sunday</option>
                          </select>
                          <i className="fa-solid fa-caret-down"></i> */}
                        </div>
                      </div>
                      <div className="col-3">
                        <div className="form-group me-2 mb-2">
                          <label>Opens at (e.g. 08:00)</label>
                          <input type="text" onChange={(evnt) => handleChange2(index, evnt)} value={opens} name="opens" className="form-control" placeholder="Opens" />
                        </div>
                      </div>
                      <div className="col-3">
                        <div className="form-group me-2 mb-2">
                          <label>Closes at (e.g. 21:00)</label>
                          <input type="text" onChange={(evnt) => handleChange2(index, evnt)} value={closes} name="closes" className="form-control" placeholder="Closes" />
                        </div>
                      </div>
                      <div className="col-1 text-center justify-content-center d-flex align-items-end mb-2">
                            {(inputFieldsEv.length > 0) ? <button className="btn btn-outline-danger dltbtn" onClick={(evnt)=>removeInputFieldsEv(index, evnt)}><i className="fa-solid fa-minus"></i></button> : ''}
                      </div>
                    </div>
                  )
                })
              :''
            }
                  <hr/>
            {(checked === false)? <div className="col mt-3 mb-3">
                <button className="btn btn-outline-success addticket" onClick={addInputFieldEv}><i className="fa-solid fa-plus"></i> Add opening hours specification</button>
              </div>
            :''}
            
            <div className="col-12">
                  <div className="form-group me-2 mb-2"> 
                  <label>sameAs Links</label>
                    <Multiselect
                      options={sportsData}
                      name="unitText"
                      displayValue="name"
                      placeholder='Select Social Links'
                      showCheckbox={true}
                      onRemove={(evnt) => handleChange4(evnt)}
                      onSelect={(evnt) => handleChange8(evnt)}
                    />
                  </div>
                </div> 
             <div className='col-md-12'>   
                    { (Object.keys(selectedVal[0]).length> 0) && selectedVal &&  Object.values(selectedVal).map((data)=>{
                        let {name, id} = data; 
                        let valdata = (name==="Twitter")?inputFieldsJp9.Twitter:(name==="Twitter")?inputFieldsJp9.Twitter:(name==="Facebook")?inputFieldsJp9.Facebook:(name==="YouTube")?inputFieldsJp9.YouTube:(name==="Instagram")?inputFieldsJp9.Instagram:(name==="Tumblr")?inputFieldsJp9.Tumblr:
                        (name==="LinkedIn")?inputFieldsJp9.LinkedIn:(name==="Pinterest")?inputFieldsJp9.Pinterest:(name==="SoundCloud")?inputFieldsJp9.SoundCloud:(name==="Wikipedia")?inputFieldsJp9.Wikipedia:(name==="Github")?inputFieldsJp9.Github:(name==="Website")?inputFieldsJp9.Website:'';
                        return (
                          <div className="form-group me-2 mb-2" key={id}>
                            <input type="text" onChange={(evnt) => handleChange9(evnt)} value={valdata} name={name} className="form-control" placeholder={name} />
                          </div>
                        )
                      })
                    }
              </div>
           
          </div>    
        </div>
        <div className='col-md-4'>
          <div className="card">
            <div className="card-header d-flex">
              <CopyToClipboard onCopy={onCopy} text={EvIsMyCopy} >
                <MyButton className="btn btn-success"><i className="fa-solid fa-copy"></i> Copy</MyButton>
              </CopyToClipboard>
              <MyButton className="btn btn-success" onClick={()=>resetFun()}><i className="fa-solid fa-arrows-rotate me-1"></i>Reset</MyButton>
            </div>
            <div className="card-body">
              {EvIsMyCopy}
            </div>
            {copied &&
              <div className="card-footer text-muted">
                <div className="p-2 btn-success rounded">✅ copied successfully</div>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  );
}

export default LocalBusiness